import { Outlet } from 'react-router'
import { IgnoreRentner } from '../ignore-rentner'
import { OverspeedPanel } from './overspeed-panel'

export function Root() {
	return (
		<>
			<div className="mb-6 flex gap-4 justify-between items-center">
				<h2 className="text-lg">Grafika</h2>
				<IgnoreRentner />
			</div>
			<OverspeedPanel />
			<div className="grow">
				<Outlet />
			</div>
		</>
	)
}
